import { render, staticRenderFns } from "./Nueva-venta.vue?vue&type=template&id=1be22efd"
import script from "./Nueva-venta.vue?vue&type=script&lang=js"
export * from "./Nueva-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports